
import { getRelatedBlogPostPreviews } from '~/graphql/queries.graphql'

export default {
  props: {
    categoryId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      blogPosts: [],
    }
  },

  async fetch() {
    const response = await this.$graphql.cms.request(
      getRelatedBlogPostPreviews,
      { category: this.categoryId }
    )

    const blogPosts = response.entries.data

    this.blogPosts = blogPosts
  },
}
